import Select from "react-select"
import React, { useEffect, useState } from "react"
import { getCountryOptions } from "common/SelectOptions/countryOptions"
import { getSystemOptions } from "common/SelectOptions/systemOptions"
import { getStageOptions } from "common/SelectOptions/stageOptions"
import { landscapingCategoryOptions } from "common/SelectOptions/landscapingCategoryOptions"
import { BooleanOptions } from "common/SelectOptions/BooleanOptions"

const ETrackerTasksFilters = ({
  filteredLocations,
  filteredCategories,
  filteredStages,
  applyFilters
}) => {
  const [locationOptions, setLocationOptions] = useState([]);
  const [stageOptions, setStageOptions] = useState([]);
  const [selectedLocations, setSelectedLocations] = useState(filteredLocations);
  const [selectedCategories, setSelectedCategories] = useState(filteredCategories);
  const [selectedStages, setSelectedStages] = useState(filteredStages);

  useEffect(() => {
    const fetchOptions = async () => {
      setLocationOptions(await getCountryOptions());
      setStageOptions(await getStageOptions());
    };
    fetchOptions();
  }, []);

  return (
    <div>
      {/* Filter by Location */}
      <div className="d-flex my-2">
        <div className="d-flex align-items-center">
          <i className="mdi mdi-map-marker-outline me-1" />
          <h6 className="mb-0">Locations:</h6>
        </div>
        <div className="ms-2" style={{ width: "100%" }}>
          <Select
            isMulti
            options={locationOptions}
            defaultValue={selectedLocations}
            className="basic-single"
            classNamePrefix="select"
            placeholder="Select locations"
            onChange={options => setSelectedLocations(options)}
          />
        </div>
      </div>

      {/* Filter by Stage */}
      <div className="d-flex my-2">
        <div className="d-flex align-items-center">
          <i className="mdi mdi-progress-check me-1" />
          <h6 className="mb-0">Stages:</h6>
        </div>
        <div className="ms-2" style={{ width: "100%" }}>
          <Select
            isMulti
            options={stageOptions}
            defaultValue={selectedStages}
            className="basic-single"
            classNamePrefix="select"
            placeholder="Select stages"
            onChange={options => setSelectedStages(options)}
          />
        </div>
      </div>

      {/* Filter by Categories */}
      <div className="d-flex my-2">
        <div className="d-flex align-items-center">
          <i className="mdi mdi-chart-bar me-1" />
          <h6 className="mb-0">Landscaping Categories:</h6>
        </div>
        <div className="ms-2" style={{ width: "100%" }}>
          <Select
            isMulti
            options={landscapingCategoryOptions}
            defaultValue={selectedCategories}
            className="basic-single"
            classNamePrefix="select"
            placeholder="Select categories"
            onChange={options => setSelectedCategories(options)}
          />
        </div>
      </div>

      {/* Apply Filters Button */}
      <div className="d-flex" style={{ justifyContent: "center" }}>
        <button
          className="btn btn-success common-button"
          style={{ width: "90%" }}
          onClick={()=>
            applyFilters(
              selectedLocations,
              selectedStages, 
              selectedCategories,
            )}
        >
          Apply
        </button>
      </div>
    </div>
  )
}

export default ETrackerTasksFilters